import { MenuItem, TextField } from '@mui/material';

/** A label-less single select for use inside QuestionField. */
export default function SelectInput({ options, value, onChange, placeholder = 'Select…', width, error = false, disabled = false }) {
  return (
    <TextField
      select
      hiddenLabel
      size="small"
      fullWidth={!width}
      disabled={disabled}
      error={error}
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      SelectProps={{ displayEmpty: true }}
      sx={width ? { width } : undefined}
    >
      <MenuItem value="" disabled>
        {placeholder}
      </MenuItem>
      {options.map((option) => (
        <MenuItem key={String(option.value)} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
